import React from 'react';
import { initI18n, useTranslation, I18nextProvider, } from '@wix/wix-i18n-config';
import { ExternalTranslationsContext, useApi } from '@wix/comments-ooi-client';
import { isEqual } from 'lodash';
let i18n;
let lastLocale;
let lastMessages;
const icuOptions = {
    formats: {
        date: {
            wcShortDate: { month: 'short', day: '2-digit' },
            wcFullDate: { month: 'short', day: '2-digit', year: 'numeric' },
        },
    },
};
export default function WixCommentsTranslationsProvider(props) {
    const [locale = 'en', messages, wcBaseParams] = useApi((state) => [
        state.baseParams?.language,
        state.translations,
        state.baseParams,
    ]);
    if (!wcBaseParams) {
        // this means that controller is not yet initialized
        return React.createElement(React.Fragment, null, props.children);
    }
    // Check if locale or messages have changed and recreate i18n instance if needed
    if (!i18n || lastLocale !== locale || !isEqual(lastMessages, messages)) {
        i18n = initI18n({
            locale,
            messages,
            icuOptions,
        });
        lastLocale = locale;
        lastMessages = messages;
    }
    return (React.createElement(I18nextProvider, { i18n: i18n },
        React.createElement(ExternalTranslationsProviderInner, { debug: { locale, messages, wcBaseParams, store: i18n.store.data }, i18n: i18n }, props.children)));
}
function ExternalTranslationsProviderInner(props) {
    const [t] = useTranslation();
    // @ts-expect-error
    t.debug = props.debug;
    // @ts-expect-error
    t.i18n = props.i18n;
    return (React.createElement(ExternalTranslationsContext.Provider, { value: React.useMemo(() => ({
            t,
        }), [t]) }, props.children));
}
//# sourceMappingURL=translations-provider.js.map